module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-cascader', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "请选择",
      "props": _vm.prop,
      "options": _vm.treeList,
      "filterable": "",
      "change-on-select": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.pointerId),
      callback: function($$v) {
        _vm.pointerId = $$v
      },
      expression: "pointerId"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_vm._v("注：所属区划决定了备案流程，请确定后操作")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67c007cc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/component/Datatreeboth.vue
// module id = 1241
// module chunks = 2